<template>
  <div class="error-page">
    <div class="error-container">
      <div class="logo-container">
        <img src="@/assets/vanvuuren.png" alt="Van Vuuren Logo" class="logo" />
      </div>
      <div class="error-icon">
        <i class="pi pi-exclamation-triangle"></i>
      </div>
      <h1 class="error-title">{{ title }}</h1>
      <p class="error-message">{{ message }}</p>
      <div class="error-actions"></div>
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: 'ErrorPage'
})
defineProps({
  title: {
    type: String,
    default: ''
  },
  message: {
    type: String,
    default: ''
  }
})
</script>

<style scoped>
.error-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background: var(--surface-ground);
}

.error-container {
  max-width: 600px;
  text-align: center;
  background: var(--surface-card);
  padding: 3rem 2rem;
  border-radius: var(--border-radius);
  box-shadow: var(--card-shadow);
}

.logo-container {
  margin-bottom: 2rem;
}

.logo {
  max-width: 200px;
  height: auto;
}

.error-icon {
  margin-bottom: 1.5rem;
}

.error-icon i {
  font-size: 8rem;
  color: var(--red-500);
  display: block;
}

.error-title {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: var(--text-color);
}

.error-message {
  font-size: 1.125rem;
  color: var(--text-color-secondary);
  margin-bottom: 2rem;
  line-height: 1.6;
}

.error-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}
</style>
